import { LocationStrategy, PathLocationStrategy, CommonModule } from '@angular/common';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpClient, HttpHandler, HttpXhrBackend, HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Injector, Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { of, from, ReplaySubject, BehaviorSubject, Subject, throwError, interval, forkJoin } from 'rxjs';
import * as i1 from '@angular/router';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { map, pluck, catchError, tap, switchMap, take, first, debounceTime, finalize, filter, timeout } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common/http';
import * as ɵngcc3 from '@angular/common';

function LstCallbackComponent_cel_loading_spinner_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "cel-loading-spinner", 2);
} }
function LstCallbackComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "div");
    ɵngcc0.ɵɵelement(3, "div");
    ɵngcc0.ɵɵelement(4, "div");
    ɵngcc0.ɵɵelement(5, "div");
    ɵngcc0.ɵɵelement(6, "div");
    ɵngcc0.ɵɵelement(7, "div");
    ɵngcc0.ɵɵelement(8, "div");
    ɵngcc0.ɵɵelement(9, "div");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const LST_ON_PRE_AUTH_CALLBACKS = new InjectionToken('LST_ON_PRE_AUTH_CALLBACKS');
const LST_ON_POST_AUTH_CALLBACKS = new InjectionToken('LST_ON_POST_AUTH_CALLBACKS');
class NoopOnPreAuth {
    onPreAuth() {
        return of(true);
    }
}
NoopOnPreAuth.ɵfac = function NoopOnPreAuth_Factory(t) { return new (t || NoopOnPreAuth)(); };
NoopOnPreAuth.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NoopOnPreAuth, factory: NoopOnPreAuth.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NoopOnPreAuth, [{
        type: Injectable
    }], null, null); })();
class NoopOnPostAuth {
    onPostAuth(payload) {
        return of(true);
    }
}
NoopOnPostAuth.ɵfac = function NoopOnPostAuth_Factory(t) { return new (t || NoopOnPostAuth)(); };
NoopOnPostAuth.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NoopOnPostAuth, factory: NoopOnPostAuth.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NoopOnPostAuth, [{
        type: Injectable
    }], null, null); })();

const getQueryParamsDictFromQueryString = (queryParamsStr = '') => {
    if (!queryParamsStr.length) {
        return {};
    }
    return queryParamsStr.split('&').reduce((params, param) => {
        const [key, value] = param.split('=');
        params[key] = value;
        return params;
    }, {});
};
const getQueryParamsStringFromDict = (queryParams = {}) => {
    return Object.entries(queryParams).reduce((params, [key, value]) => {
        if (params.length) {
            params += '&';
        }
        params += `${key}=${value}`;
        return params;
    }, '');
};

class LstNavigationService {
    constructor(location, router) {
        this.location = location;
        this.router = router;
    }
    getEnvUrl() {
        const { protocol, hostname, port } = this.location;
        const safePort = port ? `:${port}` : '';
        return `${protocol}//${hostname}${safePort}`;
    }
    navigateToRoute(route, replaceUrl = false) {
        const [path, queryParamsStr] = route.split('?');
        const queryParams = getQueryParamsDictFromQueryString(queryParamsStr);
        return from(this.router.navigate([path], { queryParams, replaceUrl }));
    }
    navigateToUrl(path) {
        this.location.href = path;
    }
}
LstNavigationService.ɵfac = function LstNavigationService_Factory(t) { return new (t || LstNavigationService)(ɵngcc0.ɵɵinject('LOCATION'), ɵngcc0.ɵɵinject(ɵngcc1.Router)); };
/** @nocollapse */ LstNavigationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstNavigationService_Factory() { return new LstNavigationService(i0.ɵɵinject("LOCATION"), i0.ɵɵinject(i1.Router)); }, token: LstNavigationService, providedIn: "root" });
/** @nocollapse */
LstNavigationService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['LOCATION',] }] },
    { type: Router }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstNavigationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['LOCATION']
            }] }, { type: ɵngcc1.Router }]; }, null); })();

const LstUserConstant = {
    defaultProfile: 'realize',
    defaultLocale: 'en',
    key: {
        castgc: 'profile.castgc',
        userLocale: 'profile.locale',
        programs: 'profile.programs',
        identityId: 'profile.identityId',
        loginTime: 'profile.logintime',
        expiresAt: 'profile.expiresat',
        rbsToken: 'profile.token',
        orgRole: 'profile.role.OrgRole1',
        primaryOrgId: 'profile.OrganizationId1',
        firstName: 'profile.firstName',
        lastName: 'profile.lastName',
        externalUserId: 'profile.externalid',
        externalEmail: 'profile.email',
        isAuthenticated: 'isAuthenticated',
        redirectUrl: 'login.redirect.url',
        policies: 'policies'
    },
};
const LstUserProfileConstant = {
    sessionStorageKey: 'userProfile'
};

const ENDPOINTS = {
    LOGIN_V2: 'account/v2/login',
    GENERATE_RBS_TOKEN: 'oauth/token',
    RESET_TOKEN_TTL: 'oauth/token/reset_ttl',
    REVOKE_TOKEN: 'oauth/token/revoke',
};
const RUMBA_ENDPOINTS = {
    LOGIN: 'sso/login',
    LOGOUT: 'sso/logout',
};
const ORG_ROLES = {
    STUDENT: 'Student',
    TEACHER: 'Teacher',
    PEARSON_ADMIN: 'Pearson Admin',
    CUSTOMER_ADMIN: 'Customer Admin',
};
const ORG_SCOPES = {
    PEARSON_ADMINISTRATOR: 'Pearson Administrator',
    CUSTOMER_ADMINISTRATOR: 'Customer Administrator',
};

const APP_ID = new InjectionToken('APP_ID');
const AUTH_GATEWAY_BASE_URL = new InjectionToken('AUTH_GATEWAY_BASE_URL');
const AUTH_CONTEXT_ID = new InjectionToken('AUTH_CONTEXT_ID');
const AUTH_GATEWAY_CLIENT_ID = new InjectionToken('AUTH_GATEWAY_CLIENT_ID');
const AUTH_CALLBACK_ROUTE = new InjectionToken('AUTH_CALLBACK_ROUTE');
const ERROR_ROUTE = new InjectionToken('ERROR_ROUTE');
const RBS_TOKEN_SCOPE = new InjectionToken('RBS_TOKEN_SCOPE');
const RBS_TOKEN_GRANT_TYPE = new InjectionToken('RBS_TOKEN_GRANT_TYPE');
const SSO_BASE_URL = new InjectionToken('SSO_BASE_URL');
const LOGOUT_SERVICE_URL = new InjectionToken('LOGOUT_SERVICE_URL');
const LOGIN_QUERY_PARAMS = new InjectionToken('LOGIN_QUERY_PARAMS');
const INCLUDE_POLICY = new InjectionToken('INCLUDE_POLICY');
const INCLUDE_LICENSED_PRODUCTS = new InjectionToken('INCLUDE_LICENSED_PRODUCTS');
const USE_USER_ROLE_AS_RBS_SCOPE = new InjectionToken('USE_USER_ROLE_AS_RBS_SCOPE');
const OFFLINE_ROUTING = new InjectionToken('OFFLINE_ROUTING');
const STORAGE_TYPE = new InjectionToken('STORAGE_TYPE');
const SEC_BEFORE_SESSION_EXPIRY_ALERT = new InjectionToken('SEC_BEFORE_SESSION_EXPIRY_ALERT');
class ConfigurationNotFoundError extends Error {
    constructor(config) {
        super(`Missing ${config} for LST-Auth Module`);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class LstAuthConfigurationService {
    constructor(injector, navigationService) {
        this.injector = injector;
        this.navigationService = navigationService;
        this.validateConfiguration();
    }
    getAppId() {
        return this.injector.get(APP_ID);
    }
    getAuthGatewayClientId() {
        return this.injector.get(AUTH_GATEWAY_CLIENT_ID);
    }
    getAuthContextId() {
        return this.injector.get(AUTH_CONTEXT_ID);
    }
    getRbsTokenScope() {
        return this.injector.get(RBS_TOKEN_SCOPE);
    }
    getRbsTokenGrantType() {
        return this.injector.get(RBS_TOKEN_GRANT_TYPE);
    }
    canUseUserRoleAsRbsScope() {
        return this.injector.get(USE_USER_ROLE_AS_RBS_SCOPE);
    }
    getRbsConfiguration() {
        return {
            scope: this.getRbsTokenScope(),
            clientId: this.getAuthGatewayClientId(),
            grant_type: this.getRbsTokenGrantType(),
        };
    }
    getErrorRoute() {
        return this.injector.get(ERROR_ROUTE);
    }
    getAuthGatewayBaseUrl() {
        return this.injector.get(AUTH_GATEWAY_BASE_URL);
    }
    getValidationServiceEndpoint() {
        return `${this.getAuthGatewayBaseUrl()}/${ENDPOINTS.LOGIN_V2}`;
    }
    getRbsTokenGenerationEndpoint() {
        return `${this.getAuthGatewayBaseUrl()}/${ENDPOINTS.GENERATE_RBS_TOKEN}`;
    }
    getResetRbsTokenTtlEndpoint() {
        return `${this.getAuthGatewayBaseUrl()}/${ENDPOINTS.RESET_TOKEN_TTL}`;
    }
    getRevokeRbsTokenEndpoint() {
        return `${this.getAuthGatewayBaseUrl()}/${ENDPOINTS.REVOKE_TOKEN}`;
    }
    getSSOBaseUrl() {
        return this.injector.get(SSO_BASE_URL);
    }
    getIncludeLicensedProducts() {
        return this.injector.get(INCLUDE_LICENSED_PRODUCTS);
    }
    getSSOLoginUrl(serviceUrl, appProfile) {
        const defaultParams = {
            service: `${serviceUrl}/${this.getAuthCallbackRoute()}`,
            profile: appProfile || LstUserConstant.defaultProfile,
        };
        Object.assign(defaultParams, this.getLoginQueryParams());
        const queryParams = getQueryParamsStringFromDict(defaultParams);
        return `${this.getSSOBaseUrl()}/${RUMBA_ENDPOINTS.LOGIN}?${queryParams}`;
    }
    getLoginQueryParams() {
        return this.injector.get(LOGIN_QUERY_PARAMS);
    }
    getSSOLogoutUrl(servicePath) {
        const logoutUrl = new URL(this.getSSOBaseUrl());
        logoutUrl.pathname = RUMBA_ENDPOINTS.LOGOUT;
        logoutUrl.searchParams.set('service', this.navigationService.getEnvUrl());
        if (servicePath && servicePath.length) {
            logoutUrl.searchParams.set('service', servicePath);
        }
        return logoutUrl.href;
    }
    getLogoutServiceUrl() {
        return this.injector.get(LOGOUT_SERVICE_URL);
    }
    getOnPreAuthCallbacks() {
        return this.injector.get(LST_ON_PRE_AUTH_CALLBACKS);
    }
    getOnPostAuthCallbacks() {
        return this.injector.get(LST_ON_POST_AUTH_CALLBACKS);
    }
    getIncludePolicy() {
        return this.injector.get(INCLUDE_POLICY);
    }
    getAuthCallbackRoute() {
        return this.injector.get(AUTH_CALLBACK_ROUTE);
    }
    getOfflineRouting() {
        return this.injector.get(OFFLINE_ROUTING);
    }
    getStorageType() {
        return this.injector.get(STORAGE_TYPE) || 'sessionStore';
    }
    getSecBeforeSessionExpiryAlert() {
        return this.injector.get(SEC_BEFORE_SESSION_EXPIRY_ALERT) || 0;
    }
    validateConfiguration() {
        if (!this.getAppId()) {
            throw new ConfigurationNotFoundError('appId');
        }
        if (!this.getAuthGatewayBaseUrl()) {
            throw new ConfigurationNotFoundError('authGatewayBaseUrl');
        }
        if (!this.getAuthGatewayClientId()) {
            throw new ConfigurationNotFoundError('authGatewayClientId');
        }
        if (!this.getAuthContextId()) {
            throw new ConfigurationNotFoundError('authContextId');
        }
        if (!this.getAuthCallbackRoute()) {
            throw new ConfigurationNotFoundError('authCallbackRoute');
        }
        if (!this.getErrorRoute()) {
            throw new ConfigurationNotFoundError('errorRoute');
        }
        if (!this.canUseUserRoleAsRbsScope() && !this.getRbsTokenScope()) {
            throw new ConfigurationNotFoundError('rbsTokenScope/useUserRoleAsRbsScope');
        }
        if (!this.getRbsTokenGrantType()) {
            throw new ConfigurationNotFoundError('rbsTokenGrantType');
        }
        if (!this.getSSOBaseUrl()) {
            throw new ConfigurationNotFoundError('ssoBaseUrl');
        }
    }
}
LstAuthConfigurationService.ɵfac = function LstAuthConfigurationService_Factory(t) { return new (t || LstAuthConfigurationService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(LstNavigationService)); };
/** @nocollapse */ LstAuthConfigurationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstAuthConfigurationService_Factory() { return new LstAuthConfigurationService(i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(LstNavigationService)); }, token: LstAuthConfigurationService, providedIn: "root" });
/** @nocollapse */
LstAuthConfigurationService.ctorParameters = () => [
    { type: Injector },
    { type: LstNavigationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstAuthConfigurationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: LstNavigationService }]; }, null); })();

class LstAuthDataService {
    constructor(http, authConfigurationService) {
        this.http = http;
        this.authConfigurationService = authConfigurationService;
    }
    revokeRbsToken(rbsToken) {
        const revokeRbsTokenUrl = this.authConfigurationService.getRevokeRbsTokenEndpoint();
        const headers = new HttpHeaders({ access_token: rbsToken });
        return this.http.post(revokeRbsTokenUrl, null, { headers });
    }
    resetTtlForRbsToken(rbsToken) {
        const resetRbsTokenTtlUrl = this.authConfigurationService.getResetRbsTokenTtlEndpoint();
        const headers = new HttpHeaders({ access_token: rbsToken });
        return this.http.put(resetRbsTokenTtlUrl, null, { headers });
    }
    getNormalizedOrgRole(orgRole) {
        let role = orgRole;
        switch (orgRole) {
            case ORG_ROLES.TEACHER:
            case ORG_ROLES.STUDENT:
                role = orgRole;
                break;
            case ORG_ROLES.PEARSON_ADMIN:
                role = ORG_SCOPES.PEARSON_ADMINISTRATOR;
                break;
            case ORG_ROLES.CUSTOMER_ADMIN:
                role = ORG_SCOPES.CUSTOMER_ADMINISTRATOR;
                break;
            default:
                role = orgRole;
        }
        return role;
    }
    getRbsToken(userId, castgc, orgRole) {
        const generateRbsTokenUrl = this.authConfigurationService.getRbsTokenGenerationEndpoint();
        const params = Object.assign({ userId }, this.authConfigurationService.getRbsConfiguration());
        if (this.authConfigurationService.canUseUserRoleAsRbsScope()) {
            params.scope = this.getNormalizedOrgRole(orgRole);
        }
        const headers = new HttpHeaders({ castgc });
        return this.http.post(generateRbsTokenUrl, params, { headers });
    }
    loginWithTicket(token, serviceUrl, { includePolicy, includeLicensedProducts = true }) {
        const validationServiceUrl = this.authConfigurationService.getValidationServiceEndpoint();
        const authContextId = this.authConfigurationService.getAuthContextId();
        const params = { serviceUrl, includeLicensedProducts, token, authContextId, includePolicy };
        return this.http.post(validationServiceUrl, params).pipe(map(({ data }) => data));
    }
}
LstAuthDataService.ɵfac = function LstAuthDataService_Factory(t) { return new (t || LstAuthDataService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(LstAuthConfigurationService)); };
/** @nocollapse */ LstAuthDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstAuthDataService_Factory() { return new LstAuthDataService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(LstAuthConfigurationService)); }, token: LstAuthDataService, providedIn: "root" });
/** @nocollapse */
LstAuthDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: LstAuthConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstAuthDataService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: LstAuthConfigurationService }]; }, null); })();

class LstStorageService {
    setItems(obj) {
        Object.keys(obj).forEach(key => this.setItem(key, obj[key]));
    }
}

class LstUserService {
    constructor(sessionStorageService) {
        this.sessionStorageService = sessionStorageService;
        this.rbsTokenSubject$ = new ReplaySubject(1);
        this.rbsToken$ = this.rbsTokenSubject$.asObservable();
        this.userProfileSubject$ = new ReplaySubject(1);
        this.userProfile$ = this.userProfileSubject$.asObservable();
        this.castgc$ = this.userProfileSubject$.pipe(pluck('castgc'));
        this.orgRole$ = this.userProfileSubject$.pipe(pluck('orgRole'));
        this.primaryOrgId$ = this.userProfileSubject$.pipe(pluck('primaryOrgId'));
        this.primaryOrgName$ = this.userProfileSubject$.pipe(pluck('primaryOrgName'));
        this.permissions$ = this.userProfileSubject$.pipe(pluck('permissions'));
        this.policies$ = this.userProfileSubject$.pipe(pluck('policies'));
        this.userId$ = this.userProfileSubject$.pipe(pluck('identityId'));
        this.username$ = this.userProfileSubject$.pipe(map(user => `${user.firstName} ${user.lastName}`));
        this.initializeFromSessionStorage();
    }
    initializeFromSessionStorage() {
        const rbsToken = this.sessionStorageService.getItem(LstUserConstant.key.rbsToken);
        if (!!rbsToken) {
            this.emitRbsToken(rbsToken);
        }
        const userProfile = this.sessionStorageService.getItem(LstUserProfileConstant.sessionStorageKey);
        if (!!userProfile) {
            this.emitUserProfile(userProfile);
        }
    }
    emitRbsToken(rbsToken) {
        this.rbsTokenSubject$.next(rbsToken);
    }
    emitUserProfile(userProfile) {
        this.userProfileSubject$.next(userProfile);
    }
    finalizeSubjects() {
        if (this.userProfileSubject$) {
            this.userProfileSubject$.complete();
        }
        if (this.rbsTokenSubject$) {
            this.rbsTokenSubject$.complete();
        }
    }
    getRbsToken() {
        return this.sessionStorageService.getItem(LstUserConstant.key.rbsToken);
    }
    getRbsTokenExpiryTime() {
        return this.sessionStorageService.getItem(LstUserConstant.key.expiresAt);
    }
    getCurrentUserId() {
        return this.sessionStorageService.getItem(LstUserConstant.key.identityId);
    }
    getCastGC() {
        return this.sessionStorageService.getItem(LstUserConstant.key.castgc);
    }
    clearUserProfile() {
        this.sessionStorageService.clear();
    }
    setRedirectUrl(url) {
        this.sessionStorageService.setItem(LstUserConstant.key.redirectUrl, url);
    }
    getRedirectUrl() {
        return this.sessionStorageService.getItem(LstUserConstant.key.redirectUrl);
    }
    getFirstName() {
        return this.sessionStorageService.getItem(LstUserConstant.key.firstName);
    }
    getLastName() {
        return this.sessionStorageService.getItem(LstUserConstant.key.lastName);
    }
    getRole() {
        return this.sessionStorageService.getItem(LstUserConstant.key.orgRole);
    }
    getPrimaryOrgId() {
        return this.sessionStorageService.getItem(LstUserConstant.key.primaryOrgId);
    }
    getPolicies() {
        return this.sessionStorageService.getItem(LstUserConstant.key.policies);
    }
    // TODO: Include all orgs details...
    setUserProfile(userProfile) {
        this.emitUserProfile(userProfile);
        this.sessionStorageService.setItem(LstUserProfileConstant.sessionStorageKey, userProfile);
        const obj = {
            [LstUserConstant.key.castgc]: userProfile.castgc,
            [LstUserConstant.key.identityId]: userProfile.identityId,
            [LstUserConstant.key.orgRole]: userProfile.orgRole,
            [LstUserConstant.key.primaryOrgId]: userProfile.primaryOrgId,
            [LstUserConstant.key.firstName]: userProfile.firstName,
            [LstUserConstant.key.lastName]: userProfile.lastName,
        };
        this.sessionStorageService.setItems(obj);
    }
    setPrograms(programs) {
        this.sessionStorageService.setItem(LstUserConstant.key.programs, this.removeDuplicates(programs));
    }
    setPolicies(policies) {
        this.sessionStorageService.setItem(LstUserConstant.key.policies, policies);
    }
    // TODO: Refactor...
    removeDuplicates(programs) {
        const productMap = {};
        const currentDate = new Date().toISOString();
        programs.forEach((currentProgram) => {
            if (currentProgram.StartDate > currentDate || currentProgram.EndDate < currentDate) {
                return;
            }
            const existingProgram = productMap[currentProgram.ProductId];
            if (!existingProgram) {
                productMap[currentProgram.ProductId] = currentProgram;
                return;
            }
            if (existingProgram.HasAccess) {
                return;
            }
            else if (currentProgram.HasAccess) {
                productMap[currentProgram.ProductId] = currentProgram;
                return;
            }
        });
        return Object.values(productMap);
    }
    setUserToken(userToken) {
        const { access_token, createdDate, expires_in } = userToken;
        const obj = {
            [LstUserConstant.key.loginTime]: createdDate,
            [LstUserConstant.key.expiresAt]: createdDate + expires_in,
            [LstUserConstant.key.rbsToken]: access_token,
        };
        this.sessionStorageService.setItems(obj);
        this.emitRbsToken(access_token);
    }
    updateUserToken(userToken) {
        const { access_token, createdDate, expires_in } = userToken;
        const obj = {
            [LstUserConstant.key.rbsToken]: access_token,
            [LstUserConstant.key.expiresAt]: (!!createdDate ? createdDate : Date.now()) + expires_in
        };
        this.sessionStorageService.setItems(obj);
        this.emitRbsToken(access_token);
    }
}
LstUserService.ɵfac = function LstUserService_Factory(t) { return new (t || LstUserService)(ɵngcc0.ɵɵinject(LstStorageService)); };
/** @nocollapse */ LstUserService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstUserService_Factory() { return new LstUserService(i0.ɵɵinject(LstStorageService)); }, token: LstUserService, providedIn: "root" });
/** @nocollapse */
LstUserService.ctorParameters = () => [
    { type: LstStorageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstUserService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LstStorageService }]; }, null); })();

class LstCustomAuthError {
}
class DefaultLstCustomAuthErrorHandler {
    shouldNavigateToCustomAuthError() {
        return of(false);
    }
}
DefaultLstCustomAuthErrorHandler.ɵfac = function DefaultLstCustomAuthErrorHandler_Factory(t) { return new (t || DefaultLstCustomAuthErrorHandler)(); };
/** @nocollapse */ DefaultLstCustomAuthErrorHandler.ɵprov = i0.ɵɵdefineInjectable({ factory: function DefaultLstCustomAuthErrorHandler_Factory() { return new DefaultLstCustomAuthErrorHandler(); }, token: DefaultLstCustomAuthErrorHandler, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DefaultLstCustomAuthErrorHandler, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

var PostMessageAction;
(function (PostMessageAction) {
    PostMessageAction["RequestRbsToken"] = "REQUEST_RBS_TOKEN";
    PostMessageAction["RbsToken"] = "RBS_TOKEN";
})(PostMessageAction || (PostMessageAction = {}));

function isValidPostMessageResponse(event) {
    return !!(event
        && event.data
        && event.data.token
        && event.data.action === PostMessageAction.RbsToken);
}
function normalizeRbsToken(token) {
    if (token.includes('Bearer')) {
        token = token.replace('Bearer', '').trim();
    }
    return token;
}
function authResponseToUserProfile(response) {
    return ({
        castgc: response.castgc,
        identityId: response.identityId,
        orgRole: response.idpResponse.data.assertion.attributes.OrgRole1,
        primaryOrgId: response.idpResponse.data.assertion.attributes.OrganizationId1,
        primaryOrgName: response.idpResponse.data.assertion.attributes.OrgName1,
        firstName: response.firstName,
        lastName: response.lastName,
        permissions: response.permissions,
        policies: response.policies,
    });
}

class LstAuthService {
    constructor(userService, navigationService, authConfigurationService, authDataService, customAuthErrorHandler) {
        this.userService = userService;
        this.navigationService = navigationService;
        this.authConfigurationService = authConfigurationService;
        this.authDataService = authDataService;
        this.customAuthErrorHandler = customAuthErrorHandler;
        this.isAuthenticatedSource = new BehaviorSubject(this.isRbsTokenValid());
        this.onBeforeExpiryNotice = new Subject();
        this.isAuthenticated$ = this.isAuthenticatedSource.asObservable();
        const { protocol, hostname, port } = window.location;
        const safePort = port ? `:${port}` : '';
        this.appUrl = `${protocol}//${hostname}${safePort}`;
    }
    isRbsTokenValid() {
        const rbsToken = this.userService.getRbsToken();
        const expiresAt = this.userService.getRbsTokenExpiryTime();
        return !!rbsToken && !!expiresAt && expiresAt > Date.now();
    }
    verifySession(returnUrl) {
        const rbsToken = this.userService.getRbsToken();
        return this.resetTtlForRbsToken(rbsToken).pipe(catchError(error => {
            console.error('[LST AUTH]: Error resetting ttl for rbs token: ', error);
            const userId = this.userService.getCurrentUserId();
            const castgc = this.userService.getCastGC();
            const orgRole = this.userService.getRole();
            return this.refreshRbsToken(userId, castgc, orgRole).pipe(catchError(err => this.onAuthError(err, returnUrl)));
        }));
    }
    clearAppSession(error) {
        return this.revokeRbsToken().pipe(tap(() => {
            // Clear the current session
            this.userService.clearUserProfile();
            // Finalize all the subjects
            this.userService.finalizeSubjects();
            // Emit isAuthenticated and errors if any
            this.isAuthenticatedSource.next(false);
            if (!!error) {
                this.isAuthenticatedSource.error(error);
            }
        }));
    }
    resetTtlForRbsToken(rbsToken) {
        return this.authDataService.resetTtlForRbsToken(rbsToken).pipe(switchMap(userToken => {
            this.userService.updateUserToken(userToken);
            return of(true);
        }), catchError(error => throwError(error)));
    }
    extendSession() {
        const rbsToken = this.userService.getRbsToken();
        this.resetTtlForRbsToken(rbsToken).subscribe(() => {
            this.watchForBeforeExpiry();
        });
    }
    onBeforeExpiry() {
        this.watchForBeforeExpiry();
        return this.onBeforeExpiryNotice.asObservable();
    }
    watchForBeforeExpiry() {
        const expirySec = this.authConfigurationService.getSecBeforeSessionExpiryAlert();
        if (expirySec < 0)
            return;
        const expiresAt = this.userService.getRbsTokenExpiryTime();
        const expiresIn = expiresAt - Date.now();
        const cutOffExpiry = expirySec * 1000;
        if (expiresIn <= cutOffExpiry) {
            this.onBeforeExpiryNotice.next(expiresIn);
        }
        else {
            const waitTime = expiresIn - cutOffExpiry;
            interval(waitTime)
                .pipe(take(1))
                .subscribe(() => {
                this.watchForBeforeExpiry();
            });
        }
    }
    refreshRbsToken(userId, castgc, orgRole) {
        return this.authDataService.getRbsToken(userId, castgc, orgRole).pipe(switchMap(userToken => {
            this.userService.setUserToken(userToken);
            return of(true);
        }), catchError(error => throwError(error)));
    }
    removeQueryParamFromUrl(url, queryParamToRemove) {
        const [head, tail] = url.split('?');
        let filteredQueryParams;
        if (queryParamToRemove && tail) {
            filteredQueryParams = tail
                .split('&')
                .filter(queryParam => !queryParam.startsWith(queryParamToRemove + '='))
                .join('&');
        }
        const doesNotNeedQueryParam = !filteredQueryParams || !filteredQueryParams.length;
        return doesNotNeedQueryParam ? head : `${head}?${filteredQueryParams}`;
    }
    handleCallback(ticket, route) {
        return this.executeOnPreAuthCallbacks().pipe(switchMap(payload => this.login(ticket, route).pipe(switchMap(() => this.executeOnPostAuthCallbacks(payload)), map(results => results.reduce((prev, curr) => !!prev && !!curr, true)), switchMap(shouldNavigate => shouldNavigate ? this.navigateToRedirectUrl() : of(true)), catchError(error => this.onAuthError(error)))));
    }
    navigateToRedirectUrl() {
        const redirectUrl = this.userService.getRedirectUrl();
        return this.navigationService.navigateToRoute(redirectUrl || '/', true);
    }
    executeOnPreAuthCallbacks() {
        const callbacks = this.authConfigurationService.getOnPreAuthCallbacks();
        return forkJoin(callbacks.map(callback => callback.onPreAuth().pipe(catchError(error => {
            console.error('error in onPreAuthCallback: ', error);
            return of(true);
        }))));
    }
    executeOnPostAuthCallbacks(payload) {
        const callbacks = this.authConfigurationService.getOnPostAuthCallbacks();
        return forkJoin(callbacks.map(callback => callback.onPostAuth(payload).pipe(catchError(error => {
            console.error('error in onPostAuthCallback: ', error);
            return of(true);
        }))));
    }
    login(ticket, route) {
        const includePolicy = this.authConfigurationService.getIncludePolicy();
        const includeLicensedProducts = this.authConfigurationService.getIncludeLicensedProducts();
        return this.authDataService.loginWithTicket(ticket, this.appUrl + '/' + route, { includePolicy, includeLicensedProducts }).pipe(map(authResponseToUserProfile), switchMap(userProfile => {
            const { identityId, castgc, orgRole } = userProfile;
            return this.authDataService.getRbsToken(identityId, castgc, orgRole).pipe(switchMap(userToken => this.onAuthSuccess(userToken, userProfile)), catchError(error => throwError(error)));
        }), catchError(error => throwError(error)));
    }
    onAuthSuccess(userToken, userProfile) {
        // Emit isAuthenticated state
        this.isAuthenticatedSource.next(true);
        // Store rbsToken + user profile + permissions in session store
        this.userService.setUserToken(userToken);
        this.userService.setUserProfile(userProfile);
        this.userService.setPrograms(userProfile.permissions);
        this.userService.setPolicies(userProfile.policies);
        return of(true);
    }
    onAuthError(error, returnUrl) {
        return this.customAuthErrorHandler.shouldNavigateToCustomAuthError().pipe(switchMap(shouldNavigate => {
            return shouldNavigate
                ? this.redirectToErrorPage(error)
                : this.redirectToSSOLoginPage(returnUrl);
        }), catchError(err => {
            console.error('[LST AUTH] Error in federated identity manager: ', err);
            return this.redirectToSSOLoginPage();
        }));
    }
    revokeRbsToken() {
        const rbsToken = this.userService.getRbsToken();
        if (!rbsToken) {
            return of(true);
        }
        return this.authDataService.revokeRbsToken(rbsToken).pipe(switchMap(() => of(true)), catchError(error => {
            console.error('[LST AUTH]: Error revoking rbs token: ', error);
            return of(false);
        }));
    }
    redirectToSSOLoginPage(serviceRoute) {
        return this.clearAppSession().pipe(switchMap(() => {
            // Set service route in the new session
            if (serviceRoute) {
                const url = this.removeQueryParamFromUrl(serviceRoute, 'ticket');
                this.userService.setRedirectUrl(url);
            }
            // Redirect to login page
            const ssoUrl = this.authConfigurationService.getSSOLoginUrl(this.appUrl);
            this.navigationService.navigateToUrl(ssoUrl);
            return of(false);
        }));
    }
    redirectToSSOLogoutPage() {
        return this.clearAppSession().pipe(switchMap(() => {
            // Redirect to logout route.
            const logoutServicePath = this.authConfigurationService.getLogoutServiceUrl();
            const ssoLogoutUrl = this.authConfigurationService.getSSOLogoutUrl(logoutServicePath);
            this.navigationService.navigateToUrl(ssoLogoutUrl);
            return of(false);
        }));
    }
    redirectToErrorPage(error) {
        return this.clearAppSession(error).pipe(switchMap(() => {
            // Redirect to error route.
            const errorRoute = this.authConfigurationService.getErrorRoute();
            return this.navigationService.navigateToRoute(errorRoute).pipe(switchMap(() => of(false)));
        }));
    }
}
LstAuthService.ɵfac = function LstAuthService_Factory(t) { return new (t || LstAuthService)(ɵngcc0.ɵɵinject(LstUserService), ɵngcc0.ɵɵinject(LstNavigationService), ɵngcc0.ɵɵinject(LstAuthConfigurationService), ɵngcc0.ɵɵinject(LstAuthDataService), ɵngcc0.ɵɵinject(LstCustomAuthError)); };
/** @nocollapse */ LstAuthService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstAuthService_Factory() { return new LstAuthService(i0.ɵɵinject(LstUserService), i0.ɵɵinject(LstNavigationService), i0.ɵɵinject(LstAuthConfigurationService), i0.ɵɵinject(LstAuthDataService), i0.ɵɵinject(LstCustomAuthError)); }, token: LstAuthService, providedIn: "root" });
/** @nocollapse */
LstAuthService.ctorParameters = () => [
    { type: LstUserService },
    { type: LstNavigationService },
    { type: LstAuthConfigurationService },
    { type: LstAuthDataService },
    { type: LstCustomAuthError }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstAuthService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LstUserService }, { type: LstNavigationService }, { type: LstAuthConfigurationService }, { type: LstAuthDataService }, { type: LstCustomAuthError }]; }, null); })();

class LstSessionStorageService extends LstStorageService {
    constructor(authConfigurationService) {
        super();
        this.authConfigurationService = authConfigurationService;
    }
    getItem(key) {
        if (sessionStorage.getItem(this.normalized(key)) !== 'undefined') {
            return JSON.parse(sessionStorage.getItem(this.normalized(key)));
        }
        return null;
    }
    setItem(key, value) {
        sessionStorage.setItem(this.normalized(key), JSON.stringify(value));
    }
    removeItem(key) {
        sessionStorage.removeItem(this.normalized(key));
    }
    clear() {
        Object.keys(sessionStorage)
            .filter(key => key.includes(this.authConfigurationService.getAppId()))
            .forEach(item => sessionStorage.removeItem(item));
    }
    normalized(key) {
        return `${this.authConfigurationService.getAppId()}-${key}`;
    }
}
LstSessionStorageService.ɵfac = function LstSessionStorageService_Factory(t) { return new (t || LstSessionStorageService)(ɵngcc0.ɵɵinject(LstAuthConfigurationService)); };
/** @nocollapse */ LstSessionStorageService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstSessionStorageService_Factory() { return new LstSessionStorageService(i0.ɵɵinject(LstAuthConfigurationService)); }, token: LstSessionStorageService, providedIn: "root" });
/** @nocollapse */
LstSessionStorageService.ctorParameters = () => [
    { type: LstAuthConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstSessionStorageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LstAuthConfigurationService }]; }, null); })();

class LstLocalStorageService extends LstStorageService {
    constructor(authConfigurationService) {
        super();
        this.authConfigurationService = authConfigurationService;
    }
    getItem(key) {
        if (localStorage.getItem(this.normalized(key)) !== 'undefined') {
            return JSON.parse(localStorage.getItem(this.normalized(key)));
        }
        return null;
    }
    setItem(key, value) {
        localStorage.setItem(this.normalized(key), JSON.stringify(value));
    }
    removeItem(key) {
        localStorage.removeItem(this.normalized(key));
    }
    clear() {
        Object.keys(localStorage)
            .filter(key => key.includes(this.authConfigurationService.getAppId()))
            .forEach(item => localStorage.removeItem(item));
    }
    normalized(key) {
        return `${this.authConfigurationService.getAppId()}-${key}`;
    }
}
LstLocalStorageService.ɵfac = function LstLocalStorageService_Factory(t) { return new (t || LstLocalStorageService)(ɵngcc0.ɵɵinject(LstAuthConfigurationService)); };
/** @nocollapse */ LstLocalStorageService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstLocalStorageService_Factory() { return new LstLocalStorageService(i0.ɵɵinject(LstAuthConfigurationService)); }, token: LstLocalStorageService, providedIn: "root" });
/** @nocollapse */
LstLocalStorageService.ctorParameters = () => [
    { type: LstAuthConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstLocalStorageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LstAuthConfigurationService }]; }, null); })();

function StorageProviderFactory(STORAGE_TYPE, LstAuthConfigurationService) {
    if (STORAGE_TYPE === 'localStore') {
        return new LstLocalStorageService(LstAuthConfigurationService);
    }
    return new LstSessionStorageService(LstAuthConfigurationService);
}

class LstCallbackComponent {
    constructor(window, route, authService, authConfigurationService) {
        this.window = window;
        this.route = route;
        this.authService = authService;
        this.authConfigurationService = authConfigurationService;
    }
    ngOnInit() {
        this.useCelSpinner = !!this.window.customElements.get('cel-loading-spinner');
        const { url, queryParams: { ticket } } = this.route.snapshot;
        if (!ticket) {
            this.authService.redirectToErrorPage()
                .pipe(first())
                .subscribe();
            return;
        }
        const route = this.authConfigurationService.getAuthCallbackRoute();
        this.authService.handleCallback(ticket, route)
            .pipe(first())
            .subscribe();
    }
}
LstCallbackComponent.ɵfac = function LstCallbackComponent_Factory(t) { return new (t || LstCallbackComponent)(ɵngcc0.ɵɵdirectiveInject('WINDOW'), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(LstAuthService), ɵngcc0.ɵɵdirectiveInject(LstAuthConfigurationService)); };
LstCallbackComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LstCallbackComponent, selectors: [["lib-lst-callback-component"]], decls: 3, vars: 2, consts: [["class", "loading-spinner", 4, "ngIf", "ngIfElse"], ["legacySpinner", ""], [1, "loading-spinner"], [1, "spinner-container"], [1, "la-ball-spin-clockwise"]], template: function LstCallbackComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LstCallbackComponent_cel_loading_spinner_0_Template, 1, 0, "cel-loading-spinner", 0);
        ɵngcc0.ɵɵtemplate(1, LstCallbackComponent_ng_template_1_Template, 10, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useCelSpinner)("ngIfElse", _r1);
    } }, directives: [ɵngcc3.NgIf], styles: [".loading-spinner[_ngcontent-%COMP%]{--height: var(--lst-auth-loader-height, 96px);--width: var(--lst-auth-loader-width, 96px);--fill-color: var(--lst-auth-loader-color, #097ae8);position:absolute;top:45%;left:50%;transform:translate(-50%,-50%)}", ".la-ball-spin-clockwise[_ngcontent-%COMP%], .la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:relative;box-sizing:border-box}.la-ball-spin-clockwise[_ngcontent-%COMP%]{display:block;font-size:0;color:#0072ee;margin:auto}.la-ball-spin-clockwise.la-dark[_ngcontent-%COMP%]{color:#0072ee}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block;float:none;background-color:currentColor;border:0 solid currentColor}.la-ball-spin-clockwise[_ngcontent-%COMP%]{width:96px;height:96px;margin:0;position:absolute;top:45%;left:50%;transform:translate(-50%,-50%)}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;width:24px;height:24px;margin-top:-4px;margin-left:-4px;border-radius:100%;animation:ball-spin-clockwise 1s infinite ease-in-out}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(1){top:5%;left:50%;animation-delay:-.875s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(2){top:18.1801948466%;left:81.8198051534%;animation-delay:-.75s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3){top:50%;left:95%;animation-delay:-.625s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(4){top:81.8198051534%;left:81.8198051534%;animation-delay:-.5s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(5){top:94.9999999966%;left:50.0000000005%;animation-delay:-.375s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(6){top:81.8198046966%;left:18.1801949248%;animation-delay:-.25s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(7){top:49.9999750815%;left:5.0000051215%;animation-delay:-.125s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(8){top:18.179464974%;left:18.1803700518%;animation-delay:0s}.la-ball-spin-clockwise.la-sm[_ngcontent-%COMP%]{width:16px;height:16px}.la-ball-spin-clockwise.la-sm[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:4px;height:4px;margin-top:-2px;margin-left:-2px}.la-ball-spin-clockwise.la-2x[_ngcontent-%COMP%]{width:64px;height:64px}.la-ball-spin-clockwise.la-2x[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:16px;height:16px;margin-top:-8px;margin-left:-8px}.la-ball-spin-clockwise.la-3x[_ngcontent-%COMP%]{width:96px;height:96px}.la-ball-spin-clockwise.la-3x[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:24px;height:24px;margin-top:-12px;margin-left:-12px}@keyframes ball-spin-clockwise{0%,to{opacity:1;transform:scale(1)}20%{opacity:1}80%{opacity:0;transform:scale(0)}}"] });
/** @nocollapse */
LstCallbackComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['WINDOW',] }] },
    { type: ActivatedRoute },
    { type: LstAuthService },
    { type: LstAuthConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstCallbackComponent, [{
        type: Component,
        args: [{
                selector: 'lib-lst-callback-component',
                template: "<cel-loading-spinner\n    *ngIf=\"useCelSpinner; else legacySpinner\"\n    class=\"loading-spinner\">\n</cel-loading-spinner>\n\n<ng-template #legacySpinner>\n    <div class=\"spinner-container\" >\n        <div class=\"la-ball-spin-clockwise\">\n            <div></div>\n            <div></div>\n            <div></div>\n            <div></div>\n            <div></div>\n            <div></div>\n            <div></div>\n            <div></div>\n        </div>\n    </div>    \n</ng-template>\n",
                styles: [".loading-spinner{--height: var(--lst-auth-loader-height, 96px);--width: var(--lst-auth-loader-width, 96px);--fill-color: var(--lst-auth-loader-color, #097ae8);position:absolute;top:45%;left:50%;transform:translate(-50%,-50%)}\n", ".la-ball-spin-clockwise,.la-ball-spin-clockwise>div{position:relative;box-sizing:border-box}.la-ball-spin-clockwise{display:block;font-size:0;color:#0072ee;margin:auto}.la-ball-spin-clockwise.la-dark{color:#0072ee}.la-ball-spin-clockwise>div{display:inline-block;float:none;background-color:currentColor;border:0 solid currentColor}.la-ball-spin-clockwise{width:96px;height:96px;margin:0;position:absolute;top:45%;left:50%;transform:translate(-50%,-50%)}.la-ball-spin-clockwise>div{position:absolute;top:50%;left:50%;width:24px;height:24px;margin-top:-4px;margin-left:-4px;border-radius:100%;animation:ball-spin-clockwise 1s infinite ease-in-out}.la-ball-spin-clockwise>div:nth-child(1){top:5%;left:50%;animation-delay:-.875s}.la-ball-spin-clockwise>div:nth-child(2){top:18.1801948466%;left:81.8198051534%;animation-delay:-.75s}.la-ball-spin-clockwise>div:nth-child(3){top:50%;left:95%;animation-delay:-.625s}.la-ball-spin-clockwise>div:nth-child(4){top:81.8198051534%;left:81.8198051534%;animation-delay:-.5s}.la-ball-spin-clockwise>div:nth-child(5){top:94.9999999966%;left:50.0000000005%;animation-delay:-.375s}.la-ball-spin-clockwise>div:nth-child(6){top:81.8198046966%;left:18.1801949248%;animation-delay:-.25s}.la-ball-spin-clockwise>div:nth-child(7){top:49.9999750815%;left:5.0000051215%;animation-delay:-.125s}.la-ball-spin-clockwise>div:nth-child(8){top:18.179464974%;left:18.1803700518%;animation-delay:0s}.la-ball-spin-clockwise.la-sm{width:16px;height:16px}.la-ball-spin-clockwise.la-sm>div{width:4px;height:4px;margin-top:-2px;margin-left:-2px}.la-ball-spin-clockwise.la-2x{width:64px;height:64px}.la-ball-spin-clockwise.la-2x>div{width:16px;height:16px;margin-top:-8px;margin-left:-8px}.la-ball-spin-clockwise.la-3x{width:96px;height:96px}.la-ball-spin-clockwise.la-3x>div{width:24px;height:24px;margin-top:-12px;margin-left:-12px}@keyframes ball-spin-clockwise{0%,to{opacity:1;transform:scale(1)}20%{opacity:1}80%{opacity:0;transform:scale(0)}}\n"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['WINDOW']
            }] }, { type: ɵngcc1.ActivatedRoute }, { type: LstAuthService }, { type: LstAuthConfigurationService }]; }, null); })();

class LstLogoutComponent {
    constructor(authService) {
        this.authService = authService;
    }
    ngOnInit() {
        // TODO: Refactor
        this.authService.redirectToSSOLogoutPage()
            .pipe(first())
            .subscribe();
    }
}
LstLogoutComponent.ɵfac = function LstLogoutComponent_Factory(t) { return new (t || LstLogoutComponent)(ɵngcc0.ɵɵdirectiveInject(LstAuthService)); };
LstLogoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LstLogoutComponent, selectors: [["lib-lst-logout"]], decls: 0, vars: 0, template: function LstLogoutComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
LstLogoutComponent.ctorParameters = () => [
    { type: LstAuthService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstLogoutComponent, [{
        type: Component,
        args: [{
                selector: 'lib-lst-logout',
                template: ""
            }]
    }], function () { return [{ type: LstAuthService }]; }, null); })();

class LstErrorComponent {
}
LstErrorComponent.ɵfac = function LstErrorComponent_Factory(t) { return new (t || LstErrorComponent)(); };
LstErrorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LstErrorComponent, selectors: [["lib-lst-error"]], decls: 2, vars: 0, template: function LstErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h1");
        ɵngcc0.ɵɵtext(1, "Something went wrong with the authentication, please try again!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstErrorComponent, [{
        type: Component,
        args: [{
                selector: 'lib-lst-error',
                template: "<h1>Something went wrong with the authentication, please try again!</h1>\n",
                styles: [""]
            }]
    }], null, null); })();

class LstPostMessageService {
    constructor(window) {
        this.window = window;
        this.messageSource = new Subject();
        this.messages$ = this.messageSource.asObservable();
        this.boundOnMessage = this.onMessage.bind(this);
        this.window.addEventListener('message', this.boundOnMessage, false);
    }
    onMessage(event) {
        this.messageSource.next(event);
    }
    ngOnDestroy() {
        // apparently, ngOnDestroy isn't invoked when the iframe is closed/destroyed ...
        this.window.removeEventListener('message', this.boundOnMessage, false);
        this.messageSource.complete();
    }
    sendMessageToParent(message, targetOrigin = '*') {
        this.window.parent.postMessage(message, targetOrigin);
    }
}
LstPostMessageService.ɵfac = function LstPostMessageService_Factory(t) { return new (t || LstPostMessageService)(ɵngcc0.ɵɵinject('WINDOW')); };
/** @nocollapse */ LstPostMessageService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstPostMessageService_Factory() { return new LstPostMessageService(i0.ɵɵinject("WINDOW")); }, token: LstPostMessageService, providedIn: "root" });
/** @nocollapse */
LstPostMessageService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['WINDOW',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstPostMessageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['WINDOW']
            }] }]; }, null); })();

class LstAuthStateService {
    constructor(authService, userService) {
        this.authService = authService;
        this.userService = userService;
        this.isAuthenticated$ = this.authService.isAuthenticated$;
        this.rbsToken$ = this.userService.rbsToken$;
        this.userProfile$ = this.userService.userProfile$;
        this.castgc$ = this.userService.castgc$;
        this.orgRole$ = this.userService.orgRole$;
        this.primaryOrgId$ = this.userService.primaryOrgId$;
        this.primaryOrgName$ = this.userService.primaryOrgName$;
        this.permissions$ = this.userService.permissions$;
        this.policies$ = this.userService.policies$;
        this.userId$ = this.userService.userId$;
        this.username$ = this.userService.username$;
    }
}
LstAuthStateService.ɵfac = function LstAuthStateService_Factory(t) { return new (t || LstAuthStateService)(ɵngcc0.ɵɵinject(LstAuthService), ɵngcc0.ɵɵinject(LstUserService)); };
/** @nocollapse */ LstAuthStateService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstAuthStateService_Factory() { return new LstAuthStateService(i0.ɵɵinject(LstAuthService), i0.ɵɵinject(LstUserService)); }, token: LstAuthStateService, providedIn: "root" });
/** @nocollapse */
LstAuthStateService.ctorParameters = () => [
    { type: LstAuthService },
    { type: LstUserService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstAuthStateService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LstAuthService }, { type: LstUserService }]; }, null); })();

const LstAuthModuleDefaultOptions = {
    authCallbackRoute: 'auth-callback',
    errorRoute: 'auth-error',
    rbsTokenGrantType: 'custom_castgc',
    storageType: 'sessionStore',
    secBeforeSessionExpiry: 0,
};
class LstAuthModule {
    static forRoot(options = {}) {
        return {
            ngModule: LstAuthModule,
            providers: [
                LstAuthService,
                LstAuthDataService,
                LstAuthConfigurationService,
                LstNavigationService,
                LstUserService,
                LstPostMessageService,
                LstAuthStateService,
                { provide: 'WINDOW', useValue: window },
                { provide: 'LOCATION', useValue: window.location },
                { provide: LocationStrategy, useClass: PathLocationStrategy },
                { provide: HttpHandler, useExisting: HttpXhrBackend },
                { provide: LstStorageService, useFactory: StorageProviderFactory,
                    deps: [STORAGE_TYPE, LstAuthConfigurationService]
                },
                { provide: LstCustomAuthError, useClass: DefaultLstCustomAuthErrorHandler },
                { provide: APP_ID, useValue: options.appId },
                { provide: OFFLINE_ROUTING, useValue: options.offlineRouting },
                { provide: STORAGE_TYPE, useValue: options.storageType || LstAuthModuleDefaultOptions.storageType },
                { provide: SEC_BEFORE_SESSION_EXPIRY_ALERT,
                    useValue: options.secBeforeSessionExpiry || LstAuthModuleDefaultOptions.secBeforeSessionExpiry },
                { provide: AUTH_GATEWAY_BASE_URL, useValue: options.authGatewayBaseUrl },
                { provide: AUTH_CONTEXT_ID, useValue: options.authContextId },
                { provide: AUTH_GATEWAY_CLIENT_ID, useValue: options.authGatewayClientId },
                { provide: AUTH_CALLBACK_ROUTE, useValue: options.authCallbackRoute || LstAuthModuleDefaultOptions.authCallbackRoute },
                { provide: ERROR_ROUTE, useValue: options.errorRoute || LstAuthModuleDefaultOptions.errorRoute },
                { provide: RBS_TOKEN_SCOPE, useValue: options.rbsTokenScope },
                { provide: RBS_TOKEN_GRANT_TYPE, useValue: options.rbsTokenGrantType || LstAuthModuleDefaultOptions.rbsTokenGrantType },
                { provide: SSO_BASE_URL, useValue: options.ssoBaseUrl },
                { provide: LOGOUT_SERVICE_URL, useValue: options.logoutServiceUrl },
                { provide: LST_ON_PRE_AUTH_CALLBACKS, useClass: NoopOnPreAuth, multi: true },
                { provide: LST_ON_POST_AUTH_CALLBACKS, useClass: NoopOnPostAuth, multi: true },
                { provide: LOGIN_QUERY_PARAMS, useValue: options.loginQueryParams || {} },
                { provide: INCLUDE_POLICY, useValue: options.includePolicy || false },
                { provide: INCLUDE_LICENSED_PRODUCTS, useValue: options.includeLicensedProducts },
                { provide: USE_USER_ROLE_AS_RBS_SCOPE, useValue: options.useUserRoleAsRbsScope },
            ]
        };
    }
}
LstAuthModule.ɵfac = function LstAuthModule_Factory(t) { return new (t || LstAuthModule)(); };
LstAuthModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LstAuthModule });
LstAuthModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            HttpClientModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstAuthModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LstCallbackComponent,
                    LstLogoutComponent,
                    LstErrorComponent,
                ],
                imports: [
                    CommonModule,
                    HttpClientModule
                ],
                exports: [
                    LstCallbackComponent,
                    LstLogoutComponent,
                    LstErrorComponent,
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LstAuthModule, { declarations: function () { return [LstCallbackComponent, LstLogoutComponent, LstErrorComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule]; }, exports: function () { return [LstCallbackComponent, LstLogoutComponent, LstErrorComponent]; } }); })();

const routes = [
    { path: 'auth-callback', component: LstCallbackComponent },
    { path: 'logout', component: LstLogoutComponent },
    { path: 'auth-error', component: LstErrorComponent },
];
class LstRouterModule {
    static getRoutes() {
        return RouterModule.forRoot(routes);
    }
}
LstRouterModule.ɵfac = function LstRouterModule_Factory(t) { return new (t || LstRouterModule)(); };
LstRouterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LstRouterModule });
LstRouterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [RouterModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstRouterModule, [{
        type: NgModule,
        args: [{ exports: [RouterModule] }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LstRouterModule, { exports: function () { return [RouterModule]; } }); })();

class LstAuthGuard {
    constructor(authService, authConfigurationService, window) {
        this.authService = authService;
        this.authConfigurationService = authConfigurationService;
        this.window = window;
    }
    canActivate(route, state) {
        const { onLine } = this.window.navigator;
        const offlineRoutingEnabled = !onLine && this.authConfigurationService.getOfflineRouting();
        if (this.authService.isRbsTokenValid()) {
            if (offlineRoutingEnabled) {
                return of(true);
            }
            return this.authService.verifySession(state.url);
        }
        if (offlineRoutingEnabled) {
            return this.authService.redirectToErrorPage('No Session available');
        }
        return this.authService.redirectToSSOLoginPage(state.url);
    }
}
LstAuthGuard.ɵfac = function LstAuthGuard_Factory(t) { return new (t || LstAuthGuard)(ɵngcc0.ɵɵinject(LstAuthService), ɵngcc0.ɵɵinject(LstAuthConfigurationService), ɵngcc0.ɵɵinject('WINDOW')); };
/** @nocollapse */ LstAuthGuard.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstAuthGuard_Factory() { return new LstAuthGuard(i0.ɵɵinject(LstAuthService), i0.ɵɵinject(LstAuthConfigurationService), i0.ɵɵinject("WINDOW")); }, token: LstAuthGuard, providedIn: "root" });
/** @nocollapse */
LstAuthGuard.ctorParameters = () => [
    { type: LstAuthService },
    { type: LstAuthConfigurationService },
    { type: undefined, decorators: [{ type: Inject, args: ['WINDOW',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstAuthGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LstAuthService }, { type: LstAuthConfigurationService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['WINDOW']
            }] }]; }, null); })();

class LstIframeAuthService {
    constructor(authService, postMessageService) {
        this.authService = authService;
        this.postMessageService = postMessageService;
        this.loader$ = new Subject();
        this.isLoading$ = this.loader$.asObservable().pipe(debounceTime(100));
    }
    canActivate() {
        this.loader$.next(true);
        return this.sendRbsTokenRequest().pipe(switchMap(() => this.getAndVerifyRbsTokenFromParent()), catchError(error => this.authService.redirectToErrorPage(error)), finalize(() => this.loader$.next(false)));
    }
    sendRbsTokenRequest() {
        return of(this.postMessageService.sendMessageToParent({ action: PostMessageAction.RequestRbsToken }));
    }
    getAndVerifyRbsTokenFromParent() {
        return this.postMessageService.messages$.pipe(filter(isValidPostMessageResponse), map(ev => normalizeRbsToken(ev.data.token)), timeout(20000), first(), switchMap(rbsToken => this.authService.resetTtlForRbsToken(rbsToken)), catchError(error => throwError(error)));
    }
}
LstIframeAuthService.ɵfac = function LstIframeAuthService_Factory(t) { return new (t || LstIframeAuthService)(ɵngcc0.ɵɵinject(LstAuthService), ɵngcc0.ɵɵinject(LstPostMessageService)); };
/** @nocollapse */ LstIframeAuthService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstIframeAuthService_Factory() { return new LstIframeAuthService(i0.ɵɵinject(LstAuthService), i0.ɵɵinject(LstPostMessageService)); }, token: LstIframeAuthService, providedIn: "root" });
/** @nocollapse */
LstIframeAuthService.ctorParameters = () => [
    { type: LstAuthService },
    { type: LstPostMessageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstIframeAuthService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LstAuthService }, { type: LstPostMessageService }]; }, null); })();

class LstIframeAuthGuard {
    constructor(iframeAuthService) {
        this.iframeAuthService = iframeAuthService;
        this.isLoading$ = this.iframeAuthService.isLoading$;
    }
    canActivate(route, state) {
        return this.iframeAuthService.canActivate();
    }
}
LstIframeAuthGuard.ɵfac = function LstIframeAuthGuard_Factory(t) { return new (t || LstIframeAuthGuard)(ɵngcc0.ɵɵinject(LstIframeAuthService)); };
/** @nocollapse */ LstIframeAuthGuard.ɵprov = i0.ɵɵdefineInjectable({ factory: function LstIframeAuthGuard_Factory() { return new LstIframeAuthGuard(i0.ɵɵinject(LstIframeAuthService)); }, token: LstIframeAuthGuard, providedIn: "root" });
/** @nocollapse */
LstIframeAuthGuard.ctorParameters = () => [
    { type: LstIframeAuthService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LstIframeAuthGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: LstIframeAuthService }]; }, null); })();

/*
 * Public API Surface of lst-auth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DefaultLstCustomAuthErrorHandler, LST_ON_POST_AUTH_CALLBACKS, LST_ON_PRE_AUTH_CALLBACKS, LstAuthDataService, LstAuthGuard, LstAuthModule, LstAuthService, LstAuthStateService, LstCallbackComponent, LstCustomAuthError, LstErrorComponent, LstIframeAuthGuard, LstLogoutComponent, LstNavigationService, LstPostMessageService, LstRouterModule, LstStorageService, LstUserService, NoopOnPostAuth, NoopOnPreAuth, APP_ID as ɵa, AUTH_GATEWAY_BASE_URL as ɵb, AUTH_CONTEXT_ID as ɵc, AUTH_GATEWAY_CLIENT_ID as ɵd, AUTH_CALLBACK_ROUTE as ɵe, ERROR_ROUTE as ɵf, RBS_TOKEN_SCOPE as ɵg, RBS_TOKEN_GRANT_TYPE as ɵh, SSO_BASE_URL as ɵi, LOGOUT_SERVICE_URL as ɵj, LOGIN_QUERY_PARAMS as ɵk, INCLUDE_POLICY as ɵl, INCLUDE_LICENSED_PRODUCTS as ɵm, USE_USER_ROLE_AS_RBS_SCOPE as ɵn, OFFLINE_ROUTING as ɵo, STORAGE_TYPE as ɵp, SEC_BEFORE_SESSION_EXPIRY_ALERT as ɵq, LstAuthConfigurationService as ɵr, StorageProviderFactory as ɵs, LstIframeAuthService as ɵt };

//# sourceMappingURL=lst-lst-auth.js.map